import * as React from 'react';
import Checkbox from '../../../../../../components/Checkbox/Checkbox';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { IFormikForm } from '../ModalMaterial/FormikMaterial';

export interface ICheckForAllMats {
    withWrapper?: boolean;
}

export const CheckForAllMats = (props: ICheckForAllMats) => {
    const { t } = useTranslation();
    const { values, setFieldValue } = useFormikContext<IFormikForm>();
    const { isForAll, hideIsForAll } = values;
    return <>{!hideIsForAll && <Checkbox title={t('material_apply_for_all')} name='applyForAll' defaultChecked={isForAll} onChange={() => setFieldValue('isForAll', !isForAll)} />}</>;
};
